import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const ClosingSection = () => {
  return (
    <div className="py-24 px-4">
      <div className="container mx-auto">
        <div className="bg-primary text-primary-foreground rounded-lg p-16 text-center shadow-overlay relative overflow-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-32 translate-x-32"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl translate-y-48 -translate-x-48"></div>
          
          <div className="relative z-10">
            <h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight">
              Ready to Thrive at Home?
            </h2>
            <div className="max-w-3xl mx-auto mb-12">
              <p className="text-xl md:text-2xl text-primary-foreground/90 leading-relaxed mb-6">
                Now you understand our mission, approach, and values. See how SeniorThrive 
                supports your goal of thriving at home with confidence and independence.
              </p>
              <p className="text-lg font-bold text-primary-foreground">
                Join thousands already creating safer, more connected lives at home.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
              <Button asChild size="lg" className="bg-white text-primary hover:bg-white/90 font-bold text-xl px-10 py-6 shadow-overlay hover:shadow-overlay transition-all duration-300">
                <Link to="/pricing">Start Your Free Trial</Link>
              </Button>
              <Button size="lg" asChild className="bg-transparent border-2 border-white text-white hover:bg-white/20 font-bold text-lg px-8 py-5">
                <Link to="/contact">Have Questions? Contact Us</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClosingSection;